module.exports = "#wrapper{\n    margin-top: 50px;\n}"